
export const environment = {
  production: false,
  apiUrl: 'https://dev-serenity-api.agitex.fr/api/v1',
  //apiUrl: 'http://localhost:8080/api/v1'
};
